import React, { useEffect, useState } from "react";
import { Form, Input, Select, Upload, Button, message, Switch } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "./Services/Api";
import {baseURL} from "./api";
const { Option } = Select;

const AddRestaurant = ({ restaurantData, onUpdateSuccess }) => {
  const [form] = Form.useForm();
  const isEditing = !!restaurantData;
  const userRole = localStorage.getItem("role");

  useEffect(() => {
    if (isEditing) {
      form.setFieldsValue({
        ...restaurantData,
        default: restaurantData.default || false, // Set default field if editing
        img: restaurantData.imgPath
          ? [
              {
                uid: "-1",
                name: "existing-image",
                status: "done",
                url: `${baseURL}${restaurantData.imgPath}`,
              },
            ]
          : [],
      });
    }
  }, [restaurantData, form, isEditing]);

  const onFinish = async (values) => {
    const { restaurantId, ...restValues } = values;

    const finalRestaurantId = isEditing ? restaurantData._id : restaurantId || generateRestaurantId();
    const uploadedFile = restValues.img?.[0]?.originFileObj || null;

    try {
      const formData = new FormData();

      Object.entries(restValues).forEach(([key, value]) => {
        if (key !== "img") formData.append(key, value);
      });

      formData.append("restaurantId", finalRestaurantId);
      formData.append("vendorId", localStorage.getItem("vendorId")); // ✅ always use vendorId from localStorage

      if (uploadedFile) {
        formData.append("img", uploadedFile);
      }

      const endpoint = isEditing
        ? `${baseURL}/editRestaurant/${restaurantData._id}`
        : `${baseURL}/addRestaurant`;

      const method = isEditing ? "put" : "post";

      await axios[method](endpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      message.success(`${isEditing ? "Updated" : "Added"} restaurant successfully!`);
      form.resetFields();
      if (onUpdateSuccess) onUpdateSuccess();
    } catch (error) {
      console.error(`Error ${isEditing ? "updating" : "adding"} restaurant:`, error);
      message.error(`Failed to ${isEditing ? "update" : "add"} restaurant.`);
    }
  };

  const generateRestaurantId = () => {
    return "restaurant-" + Math.random().toString(36).substr(2, 9);
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item
        name="restaurantId"
        label="Brand ID"
        initialValue={isEditing ? restaurantData._id : ""}
        rules={[{ required: true, message: "Please enter a restaurant ID" }]}
      >
        <Input disabled={isEditing} placeholder="Enter Brand Id" />
      </Form.Item>

      <Form.Item
        name="name"
        label="Brand Name"
        rules={[{ required: true, message: "Please enter the restaurant name" }]}
      >
        <Input placeholder="Enter Brand name" />
      </Form.Item>

      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Please select the restaurant type" }]}
      >
        <Select placeholder="Select type">
          <Option value="Frozen Foods">Frozen Foods</Option>
        </Select>
      </Form.Item>

      <Form.Item
        name="status"
        label="Status"
        rules={[{ required: true, message: "Please select the restaurant status" }]}
      >
        <Select placeholder="Select status">
          <Option value="Open">Active</Option>
          <Option value="Closed">Inactive</Option>
        </Select>
      </Form.Item>

      {/* ✅ Admin-only switch for 'default' */}
      {userRole === "admin" && (
        <Form.Item name="default" label="Default" valuePropName="checked">
          <Switch />
        </Form.Item>
      )}

      <Form.Item
        name="img"
        label="Upload Image"
        valuePropName="fileList"
        getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
      >
        <Upload name="img" listType="picture" beforeUpload={() => false}>
          <Button icon={<UploadOutlined />}>Click to Upload</Button>
        </Upload>
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {isEditing ? "Update Restaurant" : "Add Brand"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddRestaurant;
